module.exports = __webpack_public_path__ + "static/lego-components-bad-c30ae398f930fe458dd82501035094b3.jpeg";